<mat-form-field
  class="galaxy-form-field"
  [ngClass]="{
    'no-hint-message': !hint && (!internalControl.invalid || internalControl.pristine)
  }"
  appearance="outline"
>
  <mat-label *ngIf="!!label">{{ label | translate }}</mat-label>
  <span matPrefix class="currency-prefix-color">{{ symbol }} &nbsp;</span>
  <input *ngIf="disableAutoComplete" style="display: none" type="text" name="disable-autocomplete" />
  <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
  <input
    class="glxy-currency-input-field"
    #currencyInput
    matInput
    [id]="id"
    [name]="id"
    [formControl]="internalControl"
    placeholder="{{ placeholder ? (placeholder | translate) : '' }}"
    [required]="!!required"
    type="text"
    (blur)="handleBlur(currencyInput.value)"
    [autocomplete]="disableAutoComplete ? 'chrome-off' : 'on'"
  />
  <mat-hint class="galaxy-hint" *ngIf="hint">{{ hint | translate }}</mat-hint>

  <mat-error *ngIf="validatorError$ | async as validatorError">
    <ng-container *ngIf="validatorError !== ''">
      {{ validatorError | translate }}
    </ng-container>
  </mat-error>
</mat-form-field>
